// extracted by mini-css-extract-plugin
export var blueGradient = "privacyPolicy-module--blue-gradient--3Nb3Y";
export var blueGradientCitric = "privacyPolicy-module--blue-gradient-citric--RPvmb";
export var darkBlueGradient = "privacyPolicy-module--dark-blue-gradient---n7PP";
export var darkGradient = "privacyPolicy-module--dark-gradient--tx+2M";
export var lightGradient = "privacyPolicy-module--light-gradient--wz-d-";
export var page = "privacyPolicy-module--page--WMXpq";
export var purpleBlueGradient = "privacyPolicy-module--purple-blue-gradient--fc9Kz";
export var softBlueGradient = "privacyPolicy-module--soft-blue-gradient--WI8AZ";
export var softGreyGradient = "privacyPolicy-module--soft-grey-gradient--d2L76";